//import Vue from 'vue';
//import Vuex from 'vuex';
import { createStore } from 'vuex';

//Vue.use(Vuex);

//export default new Vuex.Store({
export default createStore({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  },
});
